import { Injectable } from '@angular/core';
import { AppSelectorService } from '../app-selector/app-selector.service';
import { UserInfoService } from '../user-info/user-info.service';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

declare var amplitude: any;
declare var Hansel: any;

@Injectable({
  providedIn: 'root'
})
export class AmplitudeLoggerService {
  private companyDetails: any;
  private userProps: any;
  private queuedLogs: Array<any>;
  private companyPlan: any;
  constructor(
    private appSelectorService: AppSelectorService,
    private userInfo: UserInfoService,
    private datacontextService: DatacontextService,
    private authenticationService: AuthenticationService
  ) {
    this.queuedLogs = [];
    if (!this.authenticationService.isIframe()) {
      this.fetchCompanyDetailsAndUserInfo();
    }

    this.authenticationService.onsiteUserAuth$.subscribe(() => {
      this.fetchCompanyDetailsAndUserInfo();
    });
  }

  promisifyForCompanyDetails() {
    //  Doing this weird hack to make sure we have the company details
    return new Promise((resolve, reject) => {
      this.appSelectorService.getAppListServiceReady().subscribe(data => data ? resolve(data) : reject({}));
    })
  }

  initAmplitude() {
    amplitude.getInstance().setUserId(this.userProps.email || '');
    const identify = new amplitude.Identify().set('company', this.companyDetails.name || '')
      .set('company_id', this.companyDetails.id)
      .set('company_email', this.companyDetails.email)
      .set('user_email', this.userProps.email || '');
    amplitude.getInstance().identify(identify);
  }

  resetUser() {
    amplitude.getInstance().setUserId(null);
    amplitude.getInstance().regenerateDeviceId();
  }

  private executeQueuedLogs() {
    for (let log of this.queuedLogs) {
      amplitude.getInstance().logEvent(log.eventName.toUpperCase(), log.mergedEventData);
      Hansel.logEvent(log.eventName, "amp", log.mergedEventData);
    }
    this.queuedLogs = null;
  }
  // TODO Make cta a part of eventData
  public log(eventName: string, cta: string, eventData: any) {
    const globalMeta: any = {
      path: window.location.href,
      timestamp: new Date(),
      'app_id': this.appSelectorService.getSelectedApp().id || '',
      'account_type': this.companyPlan
    };

    const mergedEventData = { ...globalMeta, ...eventData, cta };
    if (typeof this.userProps === 'undefined') {
      this.queuedLogs.push({ eventName, mergedEventData });
      return;
    }
    amplitude.getInstance().logEvent(eventName.toUpperCase(), mergedEventData);
    Hansel.logEvent(eventName, "amp", mergedEventData);
  }

  fetchCompanyDetailsAndUserInfo() {
    Promise.all([
      this.userInfo.getUserData(),
      this.promisifyForCompanyDetails(),
    ]).then((data) => {
      this.userProps = data[0];
      if (!this.authenticationService.isIframe()) {
        this.datacontextService.user.getUserCompany(resp => {
          this.companyPlan = (resp && resp.api_response && resp.api_response.companies && resp.api_response.companies[0].plan) || '';
        });
      }
      this.companyDetails = this.appSelectorService.getCompanyDetails();
    })
      .catch((error) => {
        this.userProps = error;
        this.companyDetails = error;
      })
      .finally(() => {
        this.initAmplitude();
        this.executeQueuedLogs();
      });
  }
}
